export default {
  VincularFacebook: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "vincular-filiado-facebook"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/VincularFacebook.js
// module id = 9ARQ
// module chunks = 32